import { useState, type FormEvent } from 'react'
import { supabase } from '../lib/supabase'
import { LogoComplet } from '../components/Icones'

/**
 * Choix du mot de passe après le lien reçu par courriel (invitation ou
 * « Envoyer un lien » de l'écran Utilisateurs). La session est déjà ouverte
 * par le jeton du lien (voir App.tsx, ?bienvenue=…).
 */
export function MotDePasse({ courriel, termine }: { courriel: string | null; termine: () => void }) {
  const [mdp, setMdp] = useState('')
  const [mdp2, setMdp2] = useState('')
  const [message, setMessage] = useState<string | null>(null)
  const [occupe, setOccupe] = useState(false)

  async function envoyer(e: FormEvent) {
    e.preventDefault()
    setMessage(null)
    if (mdp.length < 8) return setMessage('Au moins 8 caractères.')
    if (mdp !== mdp2) return setMessage('Les deux mots de passe ne sont pas identiques.')
    setOccupe(true)
    const { error } = await supabase.auth.updateUser({ password: mdp })
    setOccupe(false)
    if (error) {
      setMessage(
        /different from the old/i.test(error.message)
          ? "Choisis un mot de passe différent de l'ancien."
          : /Failed to fetch|NetworkError/i.test(error.message)
            ? 'Aucune connexion. Réessaie une fois le réseau revenu.'
            : error.message
      )
      return
    }
    termine()
  }

  return (
    <div className="connexion">
      <div className="marque">
        <LogoComplet hauteur={58} />
      </div>
      <h1>Choisis ton mot de passe</h1>
      <p className="intro">
        {courriel ? (
          <>
            Pour le compte <strong>{courriel}</strong>. Tu t'en serviras pour te connecter ensuite.
          </>
        ) : (
          "Tu t'en serviras pour te connecter ensuite."
        )}
      </p>
      <form onSubmit={envoyer}>
        <input type="email" value={courriel ?? ''} autoComplete="username" readOnly hidden />
        <label className="champ">
          <span>Nouveau mot de passe</span>
          <input
            type="password"
            value={mdp}
            onChange={(e) => setMdp(e.target.value)}
            autoComplete="new-password"
            minLength={8}
            required
          />
        </label>
        <label className="champ">
          <span>Le même, une 2e fois</span>
          <input
            type="password"
            value={mdp2}
            onChange={(e) => setMdp2(e.target.value)}
            autoComplete="new-password"
            minLength={8}
            required
          />
        </label>
        {message && (
          <p className="avis erreur" style={{ marginBottom: 14 }}>
            {message}
          </p>
        )}
        <button className="bouton" disabled={occupe}>
          {occupe ? 'Un instant…' : 'Enregistrer et continuer'}
        </button>
      </form>
    </div>
  )
}
